<template>
  <div :class="{ 'bg-blue': lead.place == 4 }">
    <span id="jumppoint"></span>
    <Saleslogin :registry="registry" :hash="hash" v-model="lead" v-if="lead.isHash" v-on:leademit="lead = $event"/>
    <VerticalSelling :registry="registry" :token="token" v-model="lead" v-if="lead.isToken"
                     v-on:leademit="lead = $event;"/>

    <Steps :registry="registry" :current="current" ref="steps" v-model="lead" v-on:leademit="lead = $event"
           :promiseResolved="promiseResolved" v-if="lead.place < 4 && isStart == true"/>
    <Checkout :registry="registry" ref="checkout" v-model="lead" v-on:leademit="lead = $event" v-if="lead.place == 4"/>
    <Thankyou :registry="registry" ref="checkout" :lead="lead" v-if="lead.place == 5"/>
    <MobilePanel :lead="lead" />
  </div>
</template>

<script>
import Steps from './components/Step1-4'
import Checkout from './components/Checkout'
import Thankyou from './components/Thankyou'
import Saleslogin from './components/Saleslogin'
import VerticalSelling from './components/VerticalSelling'
import MobilePanel from './components/MobilePanel'
import {setCampaignEntry} from "@/vars";
import {fetchProductRoute} from "@/helpers/productApi";
import {setPuppyEntry} from "./vars";
// for testing
//import dialog from './helpers/dialog.js'
//import testing from './components/Modal/Testing'
// for testing end


export default {
  name: 'App',
  components: {
    Steps,
    Checkout,
    Thankyou,
    Saleslogin,
    VerticalSelling,
    MobilePanel
  },
  data() {
    return {
      lead: {
        tm: false,
        advancePet: '',
        advanceHealth: '',
        advancePerson: '',
        advanceTarif: '',
        advancePayment: '',
        place: 0,
        brokerID: '',
        jumpToEnd: false,
        file: '',
        isHash: false,
        isUDSelling: false,
        isToken: false,
        errorMessage: {petbirthday: '', startdate: '', phone: '', sepa: ''}
      },
      registry: {'cc': []},
      index: 0,
      breed: '',
      colour: '',
      promiseResolved: false,
      // testing
      isStart: true,
      hash: '',
      token: '',
      current: '',
      // testing end
      path: process.env.VUE_APP_API_ENDPOINT_PRD
    }
  },
  mounted: function () {

    // set Product
    this.lead.jumpToEnd = false
    this.lead.hashR = false

    const script = document.createElement('script');
    script.src = process.env.VUE_APP_CONSENT_URL;
    script.async = true;
    document.body.appendChild(script);
   // document.addEventListener("backbutton", this.catchBackbutton, false);
  },
  beforeCreate: function () {

    // testing
    // take out isStart from layer
    /* if (!this.isStart) {
         dialog.component(testing, {

         }).then(result => {
             // set hash, set
              window.location.hash = result[0]
             this.lead.productSet = this.lead.productActive = result[0]
             this.isStart = true
         })
     }*/
    // testing


  },
  created() {

    const queryString1 = window.location.search;
    const urlParams1 = new URLSearchParams(queryString1);

    if (urlParams1.has('token')) {
      this.lead.isToken = true
      this.lead.isUDSelling = true
      this.token = urlParams1.get('token')
      localStorage.removeItem('leadData')
    }


    fetchProductRoute(process.env.VUE_APP_API_ENDPOINT_PRODUCTS + 'raw').then(response => {
          this.registry = response;
          this.registry.dogList = []
          this.registry.catList = []
          this.registry.breedList = []
          this.registry.dogColourList = []
          this.registry.catColourList = []
          this.registry.colourList = []
          this.registry.petGender = []

          var i = 0

          for (const [key] of Object.entries(this.registry.dogbreedsByName)) {
            if (urlParams.has('breed') && urlParams.get('pet') === '1' && this.registry.dogbreedsByName[key].breed_id.toString() === urlParams.get('breed')) {
              this.lead.breed = key;
            }
            this.registry.dogList[i] = {'value': key, 'label': key}
            i++;
          }

          this.registry.breedList = this.registry.dogList;

          i = 0

          for (const [key] of Object.entries(this.registry.catbreedsByName)) {
            if (urlParams.has('breed') && urlParams.get('pet') === '2' && this.registry.catbreedsByName[key].breed_id.toString() === urlParams.get('breed')) {
              this.lead.breed = key;
            }
            this.registry.catList[i] = {'value': key, 'label': key}
            i++;
          }
          i = 0

          for (const [key] of Object.entries(this.registry.dogcolourByName)) {
            this.registry.dogColourList[i] = {'value': key, 'label': key}
            i++;
          }

          this.registry.colourList = this.registry.dogColourList

          i = 0

          for (const [key] of Object.entries(this.registry.catcolourByName)) {
            this.registry.catColourList[i] = {'value': key, 'label': key}
            i++;
          }

          this.registry.petGender = [{'value': 1, 'label': 'männlich'}, {'value': 2, 'label': 'weiblich'}]
          this.registry.paymentIntervals = {
            '1': 'monatlich',
            '12': 'jährlich'
          }

          const match = document.cookie.match('(^|;)\\s*cookieconsent_dismissed\\s*=\\s*([^;]+)')

          if (match) {
            this.registry.cc = match[2].split(',')
          }

          this.promiseResolved = true

          if (this.lead.isToken) {
            history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#person')
            this.lead.place = 1
            this.current = 'Person'
            history.pushState(null, null, '#' + window.location.hash.split('#')[1] + '#zahlung')
            this.lead.place = 3
            this.current = 'Payment'
          }
        })


    this.lead.race = '1';
    this.lead.gender = 'Herr'
    this.lead.country = 'Deutschland'
    this.lead.paymentType = 'ls'
    this.lead.isLs = true
    this.lead.paymentinterval = "1"
    this.lead.place = 0
    this.lead.vetcountry = 'Deutschland'

// retrieve from local storage
    if (localStorage.getItem("leadData") != null) {
      let retrievedObject = localStorage.getItem('leadData');
      let obj = JSON.parse(retrievedObject)
      let setDate = new Date(obj['datetime'])
      setDate.setMinutes(setDate.getMinutes() + 30)
      let date = new Date();

      if (date < setDate) {
        this.lead = obj.data
        this.lead.errorMessage = {petbirthday: '', startdate: '', phone: '', sepa: ''}
        this.lead.place = 0
      } else {
        localStorage.removeItem('leadData');
      }

      if (this.token != '') {
        this.lead.isToken = true;
      }
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (document.cookie.match('(^|;)\\s*brokerID\\s*=\\s*([^;]+)')) {
      this.lead.brokerID = document.cookie.match('(^|;)\\s*brokerID\\s*=\\s*([^;]+)')[2]
    }

    if (document.cookie.match('(^|;)\\s*campagneID\\s*=\\s*([^;]+)')) {
      this.lead.campagneID = document.cookie.match('(^|;)\\s*campagneID\\s*=\\s*([^;]+)')[2]
    }

    if (document.cookie.match('(^|;)\\s*referenceID\\s*=\\s*([^;]+)')) {
      this.lead.referenceID = document.cookie.match('(^|;)\\s*referenceID\\s*=\\s*([^;]+)')[2]
    }

    if (document.cookie.match('(^|;)\\s*welcome\\s*=\\s*([^;]+)')) {
      setPuppyEntry();
    }

    // get Broker-id
    if (urlParams.has('VermittlerID')) {
      this.lead.brokerID = urlParams.get('VermittlerID')
    } else if (urlParams.has('brokerID')) {
      this.lead.brokerID = urlParams.get('brokerID')
    }

    var d1 = new Date(),
        d2 = new Date(d1);
    d2.setMinutes(d1.getMinutes() + 30);

    if (urlParams.has('ReferenzID')) {
      this.lead.referenceID = urlParams.get('ReferenzID')
      document.cookie = "referenzID=" + this.lead.referenceID + "; expires=" + d2 + "; path=/";
    }

    if (urlParams.has('KampagnenID')) {
      this.lead.campagneID = urlParams.get('campagneID')
      document.cookie = "campagneID=" + this.lead.campagneID + "; expires=" + d2 + "; path=/";
    }


    this.lead.product = {}

    let product = 1

    const productList = {
      'tierkrankenschutz/': 1,
      'tierkrankenschutz-24/': 4,
      'tierkrankenschutz-exklusiv/': 2,
      'op-kostenschutz/': 3,
      'op-kostenschutz-24/': 11,
      'op-kostenschutz-exklusiv/': 12,
      'hundehaftpflicht/': 6,
      'hundehaftpflicht-24/': 5,
      'hundehaftpflicht-exklusiv/': 7,

    }

    if (window.location.hash) {
      product = window.location.hash.split('#')[1]
      if (isNaN(product) === true) {
        if (typeof productList[product] !== 'undefined') {
          product = productList[product]
        } else {
          product = 1
        }
      }
    } else {
      const url = new URL(location);
      product = url.pathname.split('/').at(-1)
    }


    if (!product) {
      product = 1
    }
    if (product === 'consent') {
      product = sessionStorage.getItem('productActive')
    } else {
      sessionStorage.setItem('productActive', product)
    }

    this.lead.productSet = this.lead.productActive = product
    this.lead.iddValidated = false

    if (urlParams.has('birthday')) {
      this.lead.petbirthday = urlParams.get('birthday');
    }

    if (urlParams.has('pet')) {
      this.lead.race = urlParams.get('pet');
      this.lead.breed = undefined;
      this.lead.petcolour = undefined;
    }

    // preset entries
    if (urlParams.has('tm')) {
      this.lead.petbirthday = '2020-10-15'
      this.lead.petname = 'Mimi';
      this.lead.breed = 'Aberdeen Terrier'
      this.lead.race = '1';
      this.lead.petgender = 1
      this.lead.petcolour = 'weiß'

      this.lead.firstname = 'Otto';
      this.lead.lastname = 'Normalverbraucher';
      this.lead.gender = 'Herr'
      this.lead.birthday = '2000-10-18'
      this.lead.phone = '0511-712800'
      this.lead.email = 'agilatest03@gmail.com'
      this.lead.treatmentBase = false
      this.lead.street = 'Breite Str. 7'
      this.lead.number = '21'
      this.lead.zip = "30159"
      this.lead.city = "Hannover"
      this.lead.country = 'Deutschland'
      this.lead.isLs = false
      this.lead.paymentinterval = "1"
      this.lead.paymentType = 'ue'
      this.lead.firstPaymentDate = ''
      this.lead.iban = ''
      this.lead.sepa = ''
      this.lead.isLs = ''
      this.lead.tm = true
    }

    // if (document.cookie.match('(^|;)\\s*marketingcampaign\\s*=\\s*([^;]+)')) {
    //     setCampaignEntry(document.cookie.match('(^|;)\\s*marketingcampaign\\s*=\\s*([^;]+)')[2]);
    //   }
    setCampaignEntry('2503');

      if (this.lead.firstname !== '') {
        this.lead.advancePayment = this.lead.advancePerson = this.lead.advancePet = this.lead.advanceHealth = this.lead.advanceTarif = false
        this.lead.advancePaymentIcon = this.lead.advancePersonIcon = this.lead.advancePetIcon = this.lead.advanceHealthIcon = this.lead.advanceTarifIcon = ''
      }

    const match2 = document.cookie.match('(^|;)\\s*appPreSet\\s*=\\s*([^;]+)')
// hier
    if (match2 != null) {
      this.lead.race = match2[2].split('__')[1]
      if (this.lead.race == 1) {
        this.lead.breed = match2[2].split('__')[0]
      }
      this.lead.petcolour = '';
    }

    if (urlParams.has('hash')) {
      // this.lead.place = 4;
      this.lead.isHash = true
      this.hash = urlParams.get('hash')
    }

  },
  methods: {
    setPlace(place) {
      this.lead.place = place
    }
  }
}

</script>
<style>
@media (max-width: 768px) {
  .consent-trigger {
    left: -999px !important;
  }
}
.afterSendError {
  width: 100%;
  min-height: 50px;
  background-color: rgb(242, 222, 222);
  color: rgb(182, 70, 70);
  font-weight: bold;
  padding: 15px;
  font-size: 16px;
}
.input-control {
  position: relative;
  max-height: 1000000px;
}

.input-control .control {
  margin-top: 0 !important;
}

.input-control .wrapper {
  border-style: solid;
  border-color: #C6C6C6;
  background-color: #FFFFFF;
  width: 100%;
  border-width: 1px;
  min-height: 60px;
  border-radius: 6px;
  overflow: hidden;
}

.wrapper input[type="date"].date-box {
  width: 100%;
}

.error, .input__wrap.error .wrapper {
  border-color: red !important;
}

div.card__body ul {
  list-style: none;
  padding: 0;
}

div.card__body li {
  padding-left: 1em;
  display: flex;
  margin-bottom: 12px;
}

div.card__body li:before {
  content: ""; /* FontAwesome Unicode */
  font-family: "icomoon" !important;
  border-radius: 50%;
  background-color: #c0e1ff;
  color: #014e9e;
  font-size: 7px;
  padding: 3px;
  display: inline-block;
  margin-left: -1.7em; /* same as padding-left set on li */
  margin-right: 2.2em;
  height: 16px;
  width: 16px;
}

button.dark.btn.btn--green.button {
  display: inline-block;
  vertical-align: top;
  color: #fff;
  min-width: 284px;
  text-align: center;
  border: none;
  box-shadow: none;
  min-height: 56px;
  background: #014e9e;
  border-radius: 6px;
  outline: 0;
  text-transform: none;
  padding: 0 30px;
  font-family: var(--font-bold);
  font-size: 18px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  transition: color .3s ease-in-out, background .3s ease-in-out, border .3s ease-in-out, transform .3s ease-in-out, box-shadow .3s ease-in-out, opacity .3s ease-in-out, visibility .3s ease-in-out;
}

.checkbox.control.type-radio {
  padding: 20px;
}

.checkbox.control.type-radio .label {
  padding-left: 8px;
}

.jcf-scrollable {
  overflow: hidden;
  overflow-y: scroll;
  height: 116px;
}

.form .fieldset.half {
  width: 50%;
  padding-right: 10px;
}

.fieldset.address .snr.control.input-control {
  width: 10px
}

.fieldset.address .zip.control.input-control {
  width: 10px
}

@media (max-width: 600px) {
  .fieldset.address .snr.control.input-control {
    width: 100% !important
  }

  .fieldset.address .zip.control.input-control {
    width: 110%
  }
}

.back-link {
  cursor: pointer;
}

.modal .box .button-set .button {
  display: inline-block;
  vertical-align: top;
  color: #fff !important;
  min-width: 284px;
  text-align: center;
  border: none;
  box-shadow: none;
  min-height: 56px;
  background: #014e9e !important;
  border-radius: 6px;
  outline: 0;
  font-weight: 600;
  text-transform: none;
  padding: 0 30px;
  font-family: var(--font-bold);
  font-size: 18px !important;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
  transition: color .3s ease-in-out, background .3s ease-in-out, border .3s ease-in-out, transform .3s ease-in-out, box-shadow .3s ease-in-out, opacity .3s ease-in-out, visibility .3s ease-in-out;
}
.modal .box .button-set .button:hover {
  background: #146AC2 !important;
}

.modal .box .button-set .button.white {
  background: #fff !important;
  border: 1px solid #014e9e !important;
  color: #014e9e !important;
}


.has-tooltip-icon {

  width: 100%;
}

.has-tooltip-icon .text {
  display: inline-block;
  width: 100%;
}

@media (max-width: 765px) {
  .has-tooltip-icon .text {
    width: calc(100% - 16px);
  }
}

[class*=" icon-"] span {
  font-family: var(--font-regular);
}
</style>
